import { Component, Host, Prop, Watch, h } from '@stencil/core';

interface UiCmsFundPortraitFDKBody {
  isin: string;
  visualVariant: string;
}

@Component({
  tag: 'ui-cms-fund-portrait-fdk',
  shadow: false,
})
export class UiCmsFundPortraitFdk {
  @Prop({ mutable: true }) body: UiCmsFundPortraitFDKBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  render() {
    return (
      <Host>
        <fdk-fund-portrait {...this.body}></fdk-fund-portrait>
      </Host>
    );
  }
}
